import React from 'react';
import {
  Autocomplete,
  TextField,
  Box,
  FormHelperText,
} from '@mui/material';
import { useSelector } from 'react-redux';

export default function SecretsField({
  value,
  onChange,
  edit,
}) {
  const project_secrets = useSelector((state) => state.projectSecrets) || [];

  const options = project_secrets.map((secret) => ({
    id: secret.name,
    label: secret.name,
  }));

  const selectedValues = (value || [])
    .map((secretName) => {
      const secret = project_secrets.find((s) => s.name === secretName);
      return secret
        ? { id: secret.name, label: secret.name }
        : { id: secretName, label: secretName };
    })
    .filter((v) => v !== null);

  const handleChange = (event, newValue) => {
    const secretNames = newValue.map((option) => option.id);
    onChange(secretNames);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        id='secrets'
        options={options}
        value={selectedValues}
        onChange={handleChange}
        disabled={edit}
        disablePortal
        isOptionEqualToValue={(option, val) => option.id === val.id}
        getOptionLabel={(option) => option.label || ''}
        renderInput={(params) => (
          <TextField {...params} label='Secrets' />
        )}
      />
      <FormHelperText id='secrets-helper-text'>
        Select project secrets to attach to this job
      </FormHelperText>
    </Box>
  );
}

